// extracted by mini-css-extract-plugin
module.exports =  {"badge":"oUsRbK0","all-caps":"s8mNo4I","allCaps":"s8mNo4I"};